import BackButton from "../button/general/Back";

export default function PageHeading({
    title,
    description,
    backButton = false,
    backRoute,
}: {
    title: string;
    description?: string;
    backButton?: boolean;
    backRoute?: string;
}) {
    return (
        <div className="pb-2">
            {backButton && <BackButton route={backRoute} />}
            <h2 className="text-3xl font-bold tracking-tight">{title}</h2>
            <p className="text-muted-foreground">{description}</p>
        </div>
    );
}
